import { useMe } from '../lib/me';
import { Link } from '../lib/router';
import { Icon } from '../components/Icon';
import { WidgetBoard } from '../components/Widgets';
import { useHome } from '../components/CoreWidgets';
import { matchCombatRole } from '../../shared/combat-roles';

export function HomePage() {
  const { me, tx } = useMe();
  const data = useHome();
  if (!me) return null;
  const toolCount = me.nav.reduce((n, s) => n + s.tools.length, 0);
  const divisionCount = me.nav.filter((s) => s.group === 'divisions').length;

  return (
    <div className="home">
      <section className="hero">
        <div>
          <div className="eyebrow">{tx('Welcome back')}</div>
          <div className="hero-name">
            <h1>{me.user.displayName}</h1>
            {(me.identity.combat.length > 0 || me.identity.units.length > 0) && (
              <div className="hero-identity" aria-label="Combat role and unit">
                {me.identity.combat.map((c) => {
                  const role = matchCombatRole(c.name);
                  const title = c.source === 'orbat' ? 'Combat role from your ORBAT seat' : 'Combat role';
                  const label = <>{role ? <img src={role.badge} alt="" /> : <i style={{ background: c.color }} />}{c.name}</>;
                  return role && me.access.tools.includes('combined-arms')
                    ? <Link key={`c-${c.name}`} to={`/t/combined-arms/role/${role.id}`} className="hero-tag hero-tag-role" title={`${title}: about the ${role.name} role`}>{label}</Link>
                    : <span key={`c-${c.name}`} className="hero-tag hero-tag-role" title={title}>{label}</span>;
                })}
                {me.identity.units.map((u) => {
                  const t = u.slug ? me.nav.flatMap((s) => s.tools).find((x) => x.id === `unit-${u.slug}`) : undefined;
                  const label = <><Icon name="orbat" size={13} />{t?.name ?? u.name}</>;
                  return t
                    ? <Link key={`u-${u.name}`} to={`/t/${t.id}`} className="hero-tag hero-tag-unit" title="Your unit">{label}</Link>
                    : <span key={`u-${u.name}`} className="hero-tag hero-tag-unit" title="Your unit">{label}</span>;
                })}
              </div>
            )}
          </div>
          <div className="hero-roles">
            {me.roles.filter((r) => r.showcase).slice(0, 12).map((r) => (
              <span key={r.ref} className="role-chip"><i style={{ background: r.color }} />{r.name}</span>
            ))}
          </div>
        </div>
        <div className="hero-stats">
          <div><strong>{divisionCount}</strong><span>{tx('Divisions')}</span></div>
          <div><strong>{toolCount}</strong><span>{tx('Tools')}</span></div>
          <div><strong>{data?.stats.members ?? '–'}</strong><span>{tx('Members')}</span></div>
        </div>
      </section>
      <WidgetBoard />
    </div>
  );
}

